import React, { Component } from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import globalJson from '../../../data/global';
import classes from './ClientLogo.module.scss';

class ClientLogo extends Component {
    constructor(props) {
        super(props);
    }

    onClick(event){
		window.gtag('event', "client logo clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "client logo clicked "+ event.currentTarget.href,
			'value':10
          });
        
    }

    render() {
        return (
            <figure className={classes['client__logo--client-wrapper']}>
                <figcaption className={classes['client__logo--client-text']} dangerouslySetInnerHTML={{ __html: globalJson.clientLogo.paid }}></figcaption>
                <a onClick={this.onClick} href={globalJson.menu.client.link} target="_blank">
                    <img className={classes['client__logo--client']} src={getFileName(this.props.globalImages, globalJson.logos.client2)} alt="logo" />
                </a>
            </figure> 
        )
    }
}

export default ClientLogo;